import React from 'react';

import { VariantNode } from '@candu-ai/styleguide/types';
import { Variants } from 'craft/containers/Toolbox/components';
import { useMultiNodes } from 'craft/hooks';

interface Props {
  nodeIds: string[];
}

export const ChecklistGroupVariantSelector = ({ nodeIds }: Props) => {
  const {
    props,
    actions: { setProps },
  } = useMultiNodes(nodeIds);

  return (
    <Variants
      name={props.variant?.value || 'base'}
      componentName="Checklist"
      onSelectVariant={(variant: VariantNode) =>
        setProps({
          variant: variant.conditions.variant,
        })
      }
      conditions={props.variant?.value ? { variant: props.variant.value } : {}}
    />
  );
};
